import script from "./nickName.vue?vue&type=script&setup=true&name=NickName&lang=js"
export * from "./nickName.vue?vue&type=script&setup=true&name=NickName&lang=js"

import "./nickName.vue?vue&type=style&index=0&id=45d5cd0b&scoped=true&lang=css"
import "./nickName.vue?vue&type=style&index=1&id=45d5cd0b&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d5cd0b"]])

export default __exports__